module.exports = __webpack_public_path__ + "img/b-5.3.03503b24.jpg";